import { useContext } from "react";
import { Modal } from "react-bootstrap";
import { ChangePasswordContext } from "./ChangePasswordContext";
import { DashboardContext } from "../dashboard/DashboardContext";

const ChangePassword = () => {
  const {
    error, setError,
    ResetForm,
    showChangePasswordModal,
    handleCloseChangePassword,
    formData,
    handleChange,
    handleUpdate
  } = useContext(ChangePasswordContext);
  const { userData } = useContext(DashboardContext);

  const handleAction = (e) => {
    e.preventDefault();

    if (!formData.newPassword || !formData.confirmPassword) {
      setError("All fields are required!");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setError("New Password and Confirm Password do not match!");
      return;
    }

    handleUpdate(formData.userName, formData.newPassword);
  };

  return (
    <Modal
      show={showChangePasswordModal}
      onHide={handleCloseChangePassword}
      // size="lg"
      backdrop="static"
      centered
    >
      <form onSubmit={handleAction}>
        <div className="container-fluid p-4" style={{maxWidth: "500px"}}>
          <div className="d-flex align-items-center pb-2" style={{ borderBottom: '1px dotted #D5D5D5' }}>
            <h5 className="mb-0 flex-grow-1">Change Password</h5>
            <button type="button" className="btn-close" onClick={() => {
                  handleCloseChangePassword();
                  ResetForm();
                }}></button>
          </div>

          <div className="mt-3">
            <label className="form-label">User Name</label>
            <input
              type="text"
              className="form-control"
              value={formData.userName}
              name="userName"
              disabled
            />
          </div>

          <div className="mt-3">
            <label className="form-label">New Password</label>
            <input
              type="password"
              className="form-control"
              value={formData.newPassword}
              name="newPassword"
              onChange={handleChange}
            />
          </div>

          <div className="mt-3">
            <label className="form-label">Confirm Password</label>
            <input
              type="password"
              className="form-control"
              value={formData.confirmPassword}
              name="confirmPassword"
              onChange={handleChange}
            />
          </div>

          <div className="row mt-4">
            <div className="col">
              <button
                className="btn btn-secondary col w-100"
                type="button"
                onClick={() => {
                  handleCloseChangePassword();
                  ResetForm();
                }}
              >
                Cancel
              </button>
            </div>
            <div className="col">
              <button
                className="btn btn-primary col w-100"
                type="submit"
                style={{
                  background: "rgba(9, 139, 190, 1)",
                  borderColor: "rgba(9, 139, 190, 1)",
                }}
              >
                Update
              </button>
            </div>
            {error && <p style={{textAlign: "center"}} className="text-danger mt-3">{error}</p>}
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default ChangePassword;
